export default __webpack_public_path__ + "static/media/PDV.309ab038.svg";